<template lang="pug">
  .b-spec-budget(data-testid="budget-dialog")
    ._title Плановый бюджет
    template(v-if="needRegion")
      ._hint Регион нужен, чтобы искать цены в нужном городе. Значение сохранится в проекте.
      BaseInput(inputTestId="budget-region-input" v-model="region" label="Регион, например, Москва" :error="regionError")
    ._hint Порог цены — бюджет на всю спецификацию. AI постарается в него уложиться, а если не получится, предложит более дешёвые аналоги.
    BaseInput(inputTestId="budget-limit-input" v-model="limit" type="float" label="Порог цены, ₽" :error="limitError")
    textarea._comment(data-testid="budget-hint-input" v-model="hint" placeholder="Уточнения для AI, например: премиум-сегмент, без маркетплейсов")
    ._buttons
      Btn(blue data-testid="budget-submit" @click="submit") Найти цены
      Btn(grey @click="$emit('finish', false)") Отмена
</template>

<script>
import BaseInput from '@/components/BaseInput.vue';

/**
 * Окно запуска планового бюджета: регион (только если у проекта он не указан), порог цены на всю
 * спецификацию и уточнения для AI. Порог и уточнения подставляются из спецификации — так прошлые
 * значения не приходится вводить заново. Значения возвращаются странице: она сохраняет их и
 * запускает задание. Сгенерировано Claude.
 */
export default {
  name: 'SpecBudgetPopupWrappable',
  components: { BaseInput },
  data() {
    return {
      needRegion: false,
      region: '',
      limit: '',
      hint: '',
      regionError: '',
      limitError: '',
    };
  },
  methods: {
    init(params = {}) {
      this.needRegion = !!params.needRegion;
      this.limit = params.budgetLimit ?? '';
      this.hint = params.budgetHint ?? '';
    },
    submit() {
      this.regionError = '';
      this.limitError = '';
      const region = this.region.trim();
      const limit = String(this.limit ?? '').replace(/\s/g, '').replace(',', '.');

      if (this.needRegion && !region) this.regionError = 'Укажите регион';
      if (limit && (Number.isNaN(Number(limit)) || Number(limit) < 0)) this.limitError = 'Укажите сумму в рублях';
      if (this.regionError || this.limitError) return;

      this.$emit('finish', {
        region: region || null,
        budgetLimit: limit || null,
        budgetHint: this.hint.trim() || null,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.spec-budget {
  width: 460px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 14px;

  &__title {
    font-size: 24px;
    font-weight: 700;
  }

  &__hint {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__comment {
    box-sizing: border-box;
    width: 100%;
    min-height: 70px;
    padding: 8px 10px;
    border: 1px solid var(--color-super-light);
    border-radius: 6px;
    font: inherit;
    font-size: 13px;
    resize: vertical;
  }

  &__buttons {
    display: flex;
    gap: 12px;
  }
}
</style>
